import { render, staticRenderFns } from "./AllVacancies.vue?vue&type=template&id=6a6fb1c4&scoped=true&"
import script from "./AllVacancies.vue?vue&type=script&lang=js&"
export * from "./AllVacancies.vue?vue&type=script&lang=js&"
import style0 from "./AllVacancies.vue?vue&type=style&index=0&id=6a6fb1c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fb1c4",
  null
  
)

export default component.exports